import { __assign } from "tslib";
export function filterMediaByProfileId(contentItems, profileId) {
    return (contentItems !== null && contentItems !== void 0 ? contentItems : []).map(function (contentItem) {
        var _a, _b;
        if (!((_b = (_a = contentItem === null || contentItem === void 0 ? void 0 : contentItem.content) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.length)) {
            return contentItem;
        }
        return __assign(__assign({}, contentItem), { content: __assign(__assign({}, contentItem.content), { image: filterImages(contentItem.content.image, profileId) }) });
    });
}
export function filterImages(images, profileId) {
    if (!profileId) {
        return images.map(function (imageList) { return imageList === null || imageList === void 0 ? void 0 : imageList.filter(function (image) { var _a; return !((_a = image === null || image === void 0 ? void 0 : image.profileIds) === null || _a === void 0 ? void 0 : _a.length); }); });
    }
    var hasImagesWithProfile = images.some(function (imageList) { return imageList === null || imageList === void 0 ? void 0 : imageList.some(function (image) { var _a; return (_a = image === null || image === void 0 ? void 0 : image.profileIds) === null || _a === void 0 ? void 0 : _a.length; }); });
    if (!hasImagesWithProfile) {
        return images;
    }
    return images.map(function (imageList) { return imageList === null || imageList === void 0 ? void 0 : imageList.filter(function (image) { var _a; return (_a = image === null || image === void 0 ? void 0 : image.profileIds) === null || _a === void 0 ? void 0 : _a.includes(profileId); }); });
}
//# sourceMappingURL=filterMediaByProfileId.js.map